import { Paperclip, Trash2 } from "lucide-react";
import { Card, formatDate } from "../../ui";
import { fmtBRL } from "./shared";
import { ItemForm } from "./ItemForm";

const ItemRow = ({ it, isDraft, onRemove, onDownload }) => (
  <tr data-testid={`expense-item-${it.id}`} className="border-t border-slate-100">
    <td className="py-2">{formatDate(it.date)}</td>
    <td className="py-2">{it.category}</td>
    <td className="py-2 text-slate-600">{it.description || "—"}</td>
    <td className="py-2 text-right font-medium">{fmtBRL(it.amount)}</td>
    <td className="py-2">
      {it.receipt_filename ? (
        <button
          onClick={() => onDownload(it)}
          data-testid={`expense-item-receipt-${it.id}`}
          className="inline-flex items-center gap-1 text-xs text-[#002776] hover:underline"
        >
          <Paperclip size={12} />
          {it.receipt_filename}
        </button>
      ) : (
        <span className="text-xs text-slate-400">—</span>
      )}
    </td>
    <td className="py-2 text-right">
      {isDraft && (
        <button
          onClick={() => onRemove(it.id)}
          className="text-rose-600 hover:text-rose-800"
          data-testid={`expense-item-delete-${it.id}`}
          title="Remover"
        >
          <Trash2 size={14} />
        </button>
      )}
    </td>
  </tr>
);

const ItemsTable = ({ items, ...rowProps }) => (
  <table className="mt-3 min-w-full text-sm">
    <thead className="text-[10px] uppercase tracking-wide text-slate-500">
      <tr>
        <th className="text-left py-2">Data</th>
        <th className="text-left py-2">Categoria</th>
        <th className="text-left py-2">Descrição</th>
        <th className="text-right py-2">Valor</th>
        <th className="text-left py-2">Comprovante</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {items.map((it) => (
        <ItemRow key={it.id} it={it} {...rowProps} />
      ))}
    </tbody>
  </table>
);

export function ExpenseItems({ doc, reportId, isDraft, onRemove, onDownload, onAdded }) {
  const items = doc.items || [];
  return (
    <Card className="mt-4 p-5">
      <div className="flex items-center justify-between">
        <h3 className="font-serif-display text-xl">Itens de despesa</h3>
        <span className="text-xs text-slate-500">{items.length} item(ns)</span>
      </div>
      {items.length === 0 ? (
        <p className="mt-3 text-sm text-slate-500">Nenhum item adicionado ainda.</p>
      ) : (
        <ItemsTable items={items} isDraft={isDraft} onRemove={onRemove} onDownload={onDownload} />
      )}
      {isDraft && <ItemForm reportId={reportId} onAdded={onAdded} />}
    </Card>
  );
}
